<template>
  <div
    class="gradation"
    @click.stop="handleSquareBtnClick"
  >
    <span class="text" :class="className">{{text}}</span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'SKIP',
    },
    className: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.gradation{
  font-size: 24px;
  font-weight: 700;
  background-color: #5c6d99;
  color: $white;
  border-radius: 6px;
  padding: 8px 20px;
  cursor: pointer;
  transition: 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  text-transform: uppercase;
  .text{
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
  }
  .large {
    font-size: 16px;
    font-weight: bold;
  }
  &:hover {
    opacity: 0.6;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .gradation{
    &:hover {
      opacity: 1;
    }
  }
}
</style>
